import { Asset } from './asset.model'
import { Depot } from './depot.model'
import { VehicleGroup } from './vehicle-group.model'
import { VehicleInList } from './vehicle.model'

export interface DuplicateDialogData {
  context: 'reminder' | 'document'
  scope: 'vehicle' | 'asset'
  vehicleList?: VehicleInList[]
  assetList?: Asset[]
  depotList: Depot[]
  groupList: VehicleGroup[]
}

export enum DuplicateDialogScope {
  Assets = 'assets',
  Vehicles = 'vehicles',
  Groups = 'groups',
  Depots = 'depots',
}

export interface InputDuplicateData {
  [DuplicateDialogScope.Assets]: number[]
  [DuplicateDialogScope.Vehicles]: number[]
  [DuplicateDialogScope.Depots]: number[]
  [DuplicateDialogScope.Groups]: number[]
}
